import { Component, input, output } from "@angular/core";
import { DataRepositoryService } from "src/app/shared/services/data-repository/data-repository.service";
import { TaskInfoService } from "src/app/shared/services/task-info/task-info.service";
import { MapLeafletService } from "../../services/mapLeaflet.service";
import { MapViews, TBTabName } from "src/app/shared/entity/enums";

@Component({
    selector: "app-route-panel",
    templateUrl: "./route-panel.component.html",
    styleUrls: ["./route-panel.component.scss"],
    standalone: false
})
export class RoutePanelComponent {
  isTableCollapsed = input.required<boolean>();
  loading = input<boolean>();
  selectedView = input.required<string>();
  kpiData = input.required<any[]>();
  selectedKPIRoutes = input.required<any[]>();

  selectViewEvent = output<any>();
  toggleTableEvent = output<any>();
  routeSelectEvent = output<any>();
  deselectAllEvent = output<any>();
  focusDriverMarkerOnMapEvent = output<string>();

  /** Two view options are enabled, other options would be used later */
  viewOptions = [
    { label: "Task view", value: MapViews.TaskView },
    { label: "Stop view", value: MapViews.StopView },
    { label: "Unplanned Pickup", value: TBTabName.Unplannedpickup },
    { label: "Unloaded", value: TBTabName.Unloaded },
    { label: "Planned PBM", value: TBTabName.PlannedPBM },
    { label: "Push to cloud", value: TBTabName.PushToCloud },
  ];

  constructor(
    public readonly dataRepositoryService: DataRepositoryService,
    public readonly taskInfoService: TaskInfoService,
    public readonly mapLeafletService: MapLeafletService
  ) {}

  selectView(event: any) {
    this.selectViewEvent.emit(event);
  }

  toggleTable() {
    this.toggleTableEvent.emit(this.isTableCollapsed);
  }

  /**
   * Handles the p-table selectionChange event for route selection.
   */
  routeSelect(event: any) {
    this.routeSelectEvent.emit(event || []);
  }

  deselectAll() {
    this.deselectAllEvent.emit(null)
  }

  focusDriverMarkerOnMap(routeId: string) {
    this.focusDriverMarkerOnMapEvent.emit(routeId);
  }
} 